/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 *
 * @export
 * @interface GenerateUploadTokenRequest
 */
export interface GenerateUploadTokenRequest {
  /**
   * Software type identifier: 0=CM7, 1=CM4, 2=ESP
   *
   * @type {number}
   * @memberof GenerateUploadTokenRequest
   * @example 0
   */
  software_type: GenerateUploadTokenRequestSoftwareTypeEnum;

  /**
   * Optional: userId to assign this token to (specific developer)
   *
   * @type {string}
   * @memberof GenerateUploadTokenRequest
   * @example uuid-of-dev-user
   */
  assign_to_user_id?: string;

  /**
   * Token expiration in hours (default: 1)
   *
   * @type {number}
   * @memberof GenerateUploadTokenRequest
   * @example 1
   */
  expires_in_hours?: number;
}

/**
 * @export
 * @enum {string}
 */
export enum GenerateUploadTokenRequestSoftwareTypeEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
}
